export var UFOVehicleDetailsKey;
(function (UFOVehicleDetailsKey) {
    UFOVehicleDetailsKey["year"] = "year";
    UFOVehicleDetailsKey["make"] = "make_id";
    UFOVehicleDetailsKey["model"] = "model_id";
    UFOVehicleDetailsKey["option"] = "option_id";
    UFOVehicleDetailsKey["tireSize"] = "tire_size_id";
    UFOVehicleDetailsKey["vehicleUnitNumber"] = "fleet_id_no";
    UFOVehicleDetailsKey["vin"] = "vin";
    UFOVehicleDetailsKey["licensePlate"] = "license_plate";
    UFOVehicleDetailsKey["licenseState"] = "license_state_abbreviation";
    UFOVehicleDetailsKey["color"] = "color";
    UFOVehicleDetailsKey["customTireSizeSize"] = "tire_sw";
    UFOVehicleDetailsKey["customTireSizeAspectRatio"] = "tire_aspect";
    UFOVehicleDetailsKey["customTireSizeDiameter"] = "tire_rim";
    UFOVehicleDetailsKey["customTireSizeLoad"] = "load_index";
    UFOVehicleDetailsKey["customTireSizeSpeedRating"] = "speed_rating";
})(UFOVehicleDetailsKey || (UFOVehicleDetailsKey = {}));
//# sourceMappingURL=types.js.map